import { Stack } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { getDimension } from '../../../helpers/agentHelper';
import { useTranslation } from '../../../hooks/useTranslation';
import StyledChatAgentStep from '../../../styles/StyledChatAgentStep';
import StyledFormItem from '../../../styles/StyledFormItem';
import ChatConfigPreview from '../../shared/ChatConfigPreview/ChatConfigPreview';
import ColorInput from '../../shared/ColorInput/ColorInput';
import Dropdown from '../../shared/DropDown/DropDown';
import InputFileUpload from '../../shared/InputFileUpload/InputFileUpload';
import Text from '../../shared/Text/Text';
import ToolTip from '../../shared/ToolTip/ToolTip';
import WorkflowStepLabel from '../../shared/WorkflowStepLabel/WorkflowStepLabel';

interface ChatAgentBrandingStepProps {
  stepLabel?: string;
  label?: string;
  description?: string;
}

const ChatAgentBrandingStep: React.FC<ChatAgentBrandingStepProps> = ({
  stepLabel,
  label,
  description,
}) => {
  const { t } = useTranslation();

  // Get the form data from the parent component context
  const {
    formState: { errors },
  } = useFormContext();
  const formData = useWatch();

  const chatSizeOptions = [
    { label: t('Small'), value: 'small' },
    { label: t('Medium'), value: 'medium' },
    { label: t('Large'), value: 'large' },
  ];

  return (
    <StyledChatAgentStep>
      <Stack direction="column" width="364px">
        <WorkflowStepLabel
          stepLabel={stepLabel}
          label={label ?? t('Chat Agent Branding')}
          description={description}
        />
        <StyledFormItem>
          <Text type="label">{t('Header Avatar')}</Text>
          <InputFileUpload name="header_avatar_url" />
        </StyledFormItem>
        <StyledFormItem>
          <Text type="label">{t('Chat Avatar')}</Text>
          <InputFileUpload name="chat_avatar_url" />
        </StyledFormItem>
        <StyledFormItem>
          <Text type="label">{t('Theme Color')}</Text>
          <ColorInput name="theme_color" />
        </StyledFormItem>
        <StyledFormItem>
          <Text type="label">
            {t('Chat Size')}
            <ToolTip
              title={t(
                'Defines the dimensions of the chat window displayed on your website'
              )}
            />
          </Text>
          <Dropdown
            name="size"
            required={true}
            options={chatSizeOptions}
            fullWidth
            withError={!!errors.size}
            helperText={!!errors.size ? t('Chat size is required') : ''}
          />
          {formData.size && (
            <Text type="body2" color="text.secondary">
              {t('Width: {{width}}, Height: {{height}}', {
                width: getDimension(formData.size).width,
                height: getDimension(formData.size).height,
              })}
            </Text>
          )}
        </StyledFormItem>
      </Stack>
      <ChatConfigPreview formData={formData} />
    </StyledChatAgentStep>
  );
};

export default ChatAgentBrandingStep;
